/**
 * The link «Ver as decisões desta conversa» of the Chat (aim-5wc). In its own module because `DecisionsPage.tsx`
 * exports only components (react-refresh).
 */

/**
 * The window of a Chat conversation, from the URL (aim-5wc §2.6): `agent`, `sub`, `since` and `until`, all four. A
 * link with only some of them is not the Chat's, and the screen opens as always.
 *
 * Since aim-6ph.9 the window does not filter by the identity: the person and the time also bring the agent that the
 * asked agent delegated to. `agent` is the slug of the asked agent, only for the band.
 */
export interface ChatWindow {
  agent: string;
  sub: string;
  since: string;
  until: string;
}

export const CHAT_WINDOW_PARAMS = ['agent', 'sub', 'since', 'until'] as const;

export function chatWindowOfURL(params: URLSearchParams): ChatWindow | null {
  const [agent, sub, since, until] = CHAT_WINDOW_PARAMS.map((name) => params.get(name)?.trim() ?? '');
  if (!agent || !sub || !since || !until) return null;
  if (Number.isNaN(Date.parse(since)) || Number.isNaN(Date.parse(until))) return null;
  return {
    agent,
    sub,
    since: new Date(since).toISOString(),
    until: new Date(until).toISOString(),
  };
}
